
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/propertyPage/PropertyPage",
      function () {
        return require("private-next-pages/propertyPage/PropertyPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/propertyPage/PropertyPage"])
      });
    }
  